// extracted by mini-css-extract-plugin
export default {"container":"ErrorElement_container__sKbgq","main":"ErrorElement_main__sbkZk","imageContainer":"ErrorElement_imageContainer__pgkWm","customButton":"ErrorElement_customButton__6H3EF"};